import { render, staticRenderFns } from "./ShareeRequestsTable.vue?vue&type=template&id=0d790b0b"
import script from "./ShareeRequestsTable.vue?vue&type=script&lang=js"
export * from "./ShareeRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports